<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 23 22">
    <g clip-path="url(#clip0_6892_9032)">
      <path
        d="M17.6014 0H5.9543C3.10724 0 0.777832 2.32941 0.777832 5.17647V16.8235C0.777832 19.6706 3.10724 22 5.9543 22H17.6014C20.4484 22 22.7778 19.6706 22.7778 16.8235V5.17647C22.7778 2.32941 20.4484 0 17.6014 0ZM21.4837 16.8235C21.4837 18.9588 19.7367 20.7059 17.6014 20.7059H5.9543C3.81901 20.7059 2.07195 18.9588 2.07195 16.8235V9.05882H6.22607C5.85077 9.84824 5.63077 10.7153 5.63077 11.6471C5.63077 15.0376 8.38724 17.7941 11.7778 17.7941C15.1684 17.7941 17.9249 15.0376 17.9249 11.6471C17.9249 10.7153 17.7049 9.84824 17.3296 9.05882H21.4837V16.8235ZM16.6308 11.6471C16.6308 14.3259 14.4567 16.5 11.7778 16.5C9.09901 16.5 6.92489 14.3259 6.92489 11.6471C6.92489 8.96824 9.09901 6.79412 11.7778 6.79412C14.4567 6.79412 16.6308 8.96824 16.6308 11.6471ZM16.5014 7.76471C15.3755 6.39294 13.6802 5.5 11.7778 5.5C9.87548 5.5 8.18019 6.39294 7.0543 7.76471H2.07195V5.17647C2.07195 3.04118 3.81901 1.29412 5.9543 1.29412H17.6014C19.7367 1.29412 21.4837 3.04118 21.4837 5.17647V7.76471H16.5014ZM19.4778 3.52V5.20235C19.4778 5.59059 19.1672 5.90118 18.779 5.90118H17.0061C16.6178 5.90118 16.3072 5.59059 16.3072 5.20235V3.52C16.3072 3.13176 16.6178 2.82118 17.0061 2.82118H18.779C19.1672 2.82118 19.4778 3.13176 19.4778 3.52Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9032">
        <rect width="22" height="22" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
